export default [
  {
    CouponID: "01",
    VendorName: "Wellspire",
    Vendor: "100", discounttype: "Fixed",
    DiscAmount: "585",
    Limit: "100",
    StartDate: "8/7/2021",
    EndDate: "8/8/2021",
    AddCode: "XYGSUAJ",
    Status: "Active"
  },

  {
    CouponID: "02",
    VendorName: "All",
    Vendor: "100", discounttype: "Percentage",
    DiscAmount: "15",
    Limit: "400",
    StartDate: "8/7/2021",
    EndDate: "8/8/2021",
    AddCode: "YDBSUSB",
    Status: "Inactive"
  }
];
